// Import model
import { DataviewOtgVinylCatalogStyleResponse } from '../models/DataviewOtgVinylCatalogStyleResponse';

// Import base class serializer

// Import dependency types (models and enums used in properties)
import { DataView } from '../models/DataView';
import { FilterOtgVinylCatalogStyleRequest } from '../models/FilterOtgVinylCatalogStyleRequest';
import { OtgVinylCatalogStyle } from '../models/OtgVinylCatalogStyle';

// Import dependency serializers (for complex types)
import { DataViewSerializer } from './DataViewSerializer';
import { FilterOtgVinylCatalogStyleRequestSerializer } from './FilterOtgVinylCatalogStyleRequestSerializer';
import { OtgVinylCatalogStyleSerializer } from './OtgVinylCatalogStyleSerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for DataviewOtgVinylCatalogStyleResponse - handles JSON serialization and deserialization with type validation
 */
export class DataviewOtgVinylCatalogStyleResponseSerializer {
  /**
   * Deserializes a JSON string into a DataviewOtgVinylCatalogStyleResponse instance
   */
  static deserialize(json: string): DataviewOtgVinylCatalogStyleResponse {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a DataviewOtgVinylCatalogStyleResponse instance
   */
  static fromObject(obj: any): DataviewOtgVinylCatalogStyleResponse {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to DataviewOtgVinylCatalogStyleResponse');
    }


    const instance: DataviewOtgVinylCatalogStyleResponse = {
      result: obj['Result'] ? (obj['Result'] as any[]).map((item: any) =>
        OtgVinylCatalogStyleSerializer.fromObject(item)
      ) : [] as any,
      request: obj['Request'] ? FilterOtgVinylCatalogStyleRequestSerializer.fromObject(obj['Request']) : undefined as any,
      dataView: obj['DataView'] ? DataViewSerializer.fromObject(obj['DataView']) : undefined as any,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of DataviewOtgVinylCatalogStyleResponse instances
   */
  static deserializeArray(json: string): DataviewOtgVinylCatalogStyleResponse[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a DataviewOtgVinylCatalogStyleResponse instance to a JSON string
   */
  static serialize(instance: DataviewOtgVinylCatalogStyleResponse): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a DataviewOtgVinylCatalogStyleResponse instance to a plain object
   */
  static toObject(instance: DataviewOtgVinylCatalogStyleResponse): any {
    return {
      'Result': instance.result?.map((item: any) =>
        OtgVinylCatalogStyleSerializer.toObject(item)
      ),
      'Request': instance.request ? FilterOtgVinylCatalogStyleRequestSerializer.toObject(instance.request) : undefined,
      'DataView': instance.dataView ? DataViewSerializer.toObject(instance.dataView) : undefined,
    };
  }

  /**
   * Serializes an array of DataviewOtgVinylCatalogStyleResponse instances to a JSON string
   */
  static serializeArray(instances: DataviewOtgVinylCatalogStyleResponse[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
